import React, { useState, useEffect } from "react";
import Styles from "./Carousel.module.css";
import imageSlide from "./CarouselData";



function Carousel() {
	const [currentState, setCurrentState] = useState(0);
	
	useEffect(() => {
		const timer = setTimeout(() => {
			if (currentState === 2) {
				setCurrentState(0);
			} else {
				setCurrentState(currentState + 1);
			}
		}, 3000);

		return () => {
			clearTimeout(timer);
		};
	}, [currentState]);

	const bgImageStyle = {
		backgroundImage: `url(${imageSlide[currentState].url})`,
		backgroundPosition: "center",
		backgroundSize: "cover",
		height: "100%",
	};

	const goToNext = (index) => {
		setCurrentState(index);
	};

	return (
		<div className={Styles.countainerStyle}>
			<div
				style={bgImageStyle}
			></div>
			<div className={Styles.title}>
				<div>
					<h1>{imageSlide[currentState].title}</h1>
				</div>

				<div className={Styles.indicator}>
					{imageSlide.map((image, index) => (
						<span
							className={
								index === currentState
									? Styles.indicatorActive
									: Styles.indicatorInactive
							}
							key={index}
							onClick={() => goToNext(index)}
						></span>
					))}
				</div>
			</div>
		</div>
	);
}

export default Carousel;
